var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2724_2270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8771 6C15.4971 6 17.7571 7.86 18.2671 10.43L18.5671 11.93L20.0971 12.04C21.6571 12.14 22.8771 13.45 22.8771 15C22.8771 16.65 21.5271 18 19.8771 18H6.87714C4.66714 18 2.87714 16.21 2.87714 14C2.87714 11.95 4.40714 10.24 6.43714 10.03L7.50714 9.92L8.00714 8.97C8.95714 7.14 10.8171 6 12.8771 6ZM12.8771 4C9.98714 4 7.47714 5.64 6.22714 8.04C3.21714 8.36 0.877136 10.91 0.877136 14C0.877136 17.31 3.56714 20 6.87714 20H19.8771C22.6371 20 24.8771 17.76 24.8771 15C24.8771 12.36 22.8271 10.22 20.2271 10.04C19.5471 6.59 16.5171 4 12.8771 4Z",
    fill: "#030712"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2724_2270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.877136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.45cb57d051849b46b28d9bcc7122e06f.svg";
export { ForwardRef as ReactComponent };